import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/core/service/Auth/authService';
import { CookieService } from 'ngx-cookie-service';
import { LogService } from '../service/log/logservice';
import { offlineService } from '../service/notification/Notification.service';
@Injectable({
  providedIn: 'root',
})
export class SecureInnerPagesGuard implements CanActivate {
  expiryTime: any;
  constructor(
    private authService: AuthService,
    private router: Router,
    private cookieService: CookieService,
    private logService: LogService,
    private offlineNotify: offlineService
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (this.authService.isLoggedIn) {
      window.alert('You are already signed in, access denied!');
      this.expiryTime = JSON.parse(
        sessionStorage.getItem('ExpiryTime') || '{}'
      );
      let date = new Date().getTime();
      let expirationDate = new Date(this.expiryTime).getTime();
      this.logService.autoLogout(expirationDate - date);
      let id = {
        id: JSON.parse(sessionStorage.getItem('reconnectId') || '{}'),
      };
      this.offlineNotify.emit('reconnect', id);
      this.router.navigate(['/sub/Dashboard']);
    }
    return true;
  }
}
